import { INIT_I18N_SUCCESS, CHANGE_LOCALE } from '../actions/i18n/index';
import messages_en from '../resources/i18n/messages_en';

const doI18n = (state, action) => {
  switch (action.type) {
    case INIT_I18N_SUCCESS:
      return {
        status: INIT_I18N_SUCCESS,
        locale: action.i18nParams.locale,
        localeMessage: action.i18nParams.localeMessage
      }
    default:
      return state;
    }
}

const i18nReducers = (state = {
  status: CHANGE_LOCALE,
  locale: 'en',
  localeMessage: messages_en
}, action) => {
  switch (action.type) {
    default:
      return doI18n(state, action);
  }
}

export default i18nReducers;